<template>
	<div>
		<div class="luminance-page">
			<div class="bg"></div>
			<time-num></time-num>
			<div class="luminanceTop">
				<div class="top">
					<img src="./../../assets/microscope/selectIcon.png" alt="" />当前倍镜
				</div>
				<div class="bottom">
					<div class="left">
						<div class="multiplier">
							<img src="./../../assets/microscope/multiplierIcon.png" alt="" srcset="" />
						</div>
						<div class="text">10x</div>
						<div class="solid"></div>
					</div>
					<div class="right">
						<div class="text">当前图片为10倍镜视野</div>
					</div>
				</div>
			</div>
			<div class="content">
				<div class="stem">
					<div>下方玻片的4个区域中，只有一个具有诊断意义。</div>
					<div>请点击放大查阅，找到该区域。</div>
				</div>
				<div class="smallBox">
					<div class="tip">
						<div>点击图片</div>
						<div>查看大图</div>
					</div>
					<div class="imgBox" v-if="currentItem">
						<img :src="currentItem.lowImage1" :class="status === 'A' ? 'border' : ''"
							@click="handleImg('A')" class="lowImage" alt="" srcset="" />
						<img :src="currentItem.lowImage2" :class="status === 'B' ? 'border' : ''"
							@click="handleImg('B')" class="lowImage" alt="" srcset="" />
						<img :src="currentItem.lowImage3" :class="status === 'C' ? 'border' : ''"
							@click="handleImg('C')" class="lowImage" alt="" srcset="" />
						<img :src="currentItem.lowImage4" :class="status === 'D' ? 'border' : ''"
							@click="handleImg('D')" class="lowImage" alt="" srcset="" />
						<img v-if="fingerFlag" class="finger" src="./../../assets/home/finger.gif" alt=""
							@click="handleFinger" srcset="" />
					</div>
				</div>
				<div class="maxBox">
					<img :src="slidePaperLowImage" :style="{
              opacity: currentNum / 10,
              filter: `alpha(${currentNum / 10})`,
            }" alt="" />
				</div>
				<div class="explain">*请注意：当前环节选择错误不影响得分</div>
			</div>
			<div class="footer">
				<!-- <div class="nextquestionactive" @click="$router.replace('/microscope/luminance')">
					<img class="next1" src="./../../assets/home/previous.png"></img>上一步
				</div> -->
				<div @click="handleBtn" class="btn">
					<img src="./../../assets/microscope/answerIcon.png" alt="" />
					确认选区, 进行下一步
				</div>
			</div>
			<div class="mask" v-if="isShow"></div>
			<div class="dialog" v-if="isShow">
				<div class="title">提示！</div>
				<div class="text mt100">您选择的区域不具有诊断意义，</div>
				<div class="text">请重新选择。</div>
				<div class="flex">
					<div @click="handleClose" class="btn">确认</div>
				</div>
			</div>
		</div>
		<mi-xin></mi-xin>
	</div>
</template>

<script>
	import MiXin from "../mixins/index";
	import {
		checkAnswer
	} from "@/api/system/exam";
	import {
		mapState,
		mapMutations
	} from "vuex";
	import TimeNum from "../mixins/timeNum";
	import {
		submitExamCommitSingerAnswer
	} from "../../api/system/exam";
	export default {
		name: "Home2026",
		components: {
			MiXin,
			TimeNum,
		},
		data() {
			return {
				isShow: false,
				status: "A",
				isFrist: true,
				currentItem: null,
				currentNum: null,
				slidePaperLowImage: null,
				fingerFlag: true,
			};
		},
		computed: {
			...mapState("microscope", ["num", "slideType", "slidePaper", "examDetailId", "detail1", "detail2"]),
		},
		mounted() {
			this.currentItem = this.slidePaper[this.slideType];
			this.slidePaperLowImage = this.slidePaper[this.slideType].lowImage1;
			this.currentNum = this.num;
		},
		methods: {
			...mapMutations("microscope", ["handleMicroscope"]),
			// 选中低背景图片
			handleImg(type) {
				this.status = type;
				this.fingerFlag = false;
				switch (type) {
					case "A":
						this.slidePaperLowImage = this.currentItem.lowImage1;
						break;
					case "B":
						this.slidePaperLowImage = this.currentItem.lowImage2;
						break;
					case "C":
						this.slidePaperLowImage = this.currentItem.lowImage3;
						break;
					case "D":
						this.slidePaperLowImage = this.currentItem.lowImage4;
				}
				this.$forceUpdate();
			},

			//关闭指引
			handleFinger() {
				this.fingerFlag = false;
				this.handleImg("A");
			},

			// 提交答案
			handleBtn() {
				let item = {
					answers: this.status,
					questionId: this.currentItem.lowQuestion.id,
				};
				// if (this.status !== null && this.isFrist) {
				// 	this.handleMicroscope({
				// 		key: this.slideType === 0 ? "detail1" : "detail2",
				// 		value: item,
				// 	});
				// 	this.isFrist = false;
				// }
				checkAnswer(item).then((res) => {
					if (res.data.data) {
						this.handleMicroscope({
							key: this.slideType === 0 ? "detail1" : "detail2",
							value: item,
						});
						let backendAnswers = {
							paper1Id: this.slidePaper[0].id,
							paper2Id: this.slidePaper[1].id,
							detail1: this.detail1,
							detail2: this.detail2,
						};
						submitExamCommitSingerAnswer({
							backendAnswers: JSON.stringify(backendAnswers),
							paperId: this.slideType,
							questionId: '1',
							answers: JSON.stringify({
								detail1: this.detail1,
								detail2: this.detail2
							}),
							extractDetailId: this.examDetailId,
						}).then((response) => {
							this.$router.replace("/microscope/highPoweOne");
						});

					} else {
						this.isShow = true;
					}
				});
			},

			// 关闭错误弹出框
			handleClose() {
				this.isShow = false;
			},
		},
	};
</script>

<style lang="less" scoped>
	.luminance-page {
		width: 100%;
		// height: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/xwjBg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		position: relative;

		.bg {
			height: 10px;
		}

		.luminanceTop {
			width: 653px;
			height: 282px;
			background: rgba(255, 255, 255, 0.85);
			border: 2px solid #ffffff;
			border-radius: 60px;
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			margin: 0 auto;

			.top {
				margin-left: 48px;
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				margin-top: 28px;

				img {
					width: 30px;
					vertical-align: middle;
					margin-right: 24px;
				}
			}

			.bottom {
				margin-left: 75px;
				margin-top: 15px;
				display: flex;

				.left {
					.multiplier {
						width: 134px;
						height: 134px;
						background: rgba(171, 59, 145, 0.2);
						border-radius: 50%;
						position: relative;

						img {
							position: absolute;
							top: 20px;
							left: 40px;
							display: block;
							width: 55px;
							margin: 0 auto;
						}
					}

					.text {
						font-size: 25px;
						font-family: HarmonyOS Sans SC;
						font-weight: 500;
						color: #333333;
						text-align: center;
						margin-top: 8px;
					}

					.solid {
						width: 134px;
						height: 5px;
						background: #ab3b91;
						border-radius: 2px;
						margin-top: 14px;
					}
				}

				.right {
					margin-left: 64px;
					margin-top: 50px;

					.text {
						font-size: 30px;
						font-family: HarmonyOS Sans SC;
						font-weight: 500;
						color: #4c4c4c;
						line-height: 50px;
						text-align: center;
					}
				}
			}
		}

		.content {
			width: 653px;
			height: 1100px;
			background: rgba(255, 255, 255, 0.85);
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border-radius: 60px;
			margin: 0 auto;
			padding-top: 1px;
			margin-top: 40px;

			.stem {
				font-size: 26px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				color: #4d4d4d;
				margin-top: 50px;
				text-align: center;
			}

			.smallBox {
				position: relative;

				.imgBox {
					width: 328px;
					margin: 0 auto;
					margin-top: 40px;
					display: flex;
					flex-wrap: wrap;
					// border-radius: 20px;
					overflow: hidden;

					.lowImage {
						width: 162px;
						margin-right: 2px;
						margin-bottom: 2px;
						// height: 102px;
					}

					.finger {
						width: 100px;
						position: absolute;
						top: 10px;
						left: 200px;
					}

					.border {
						border: 2px solid #ab3b91;
						box-sizing: border-box;
					}
				}

				.tip {
					position: absolute;
					left: 60px;
					top: 25px;
					font-size: 22px;
					font-family: HarmonyOS Sans SC;
					font-weight: 400;
					color: #ab3b91;
				}
			}

			.maxBox {
				width: 608px;
				height: 374px;
				margin: 0 auto;
				margin-top: 24px;
				border-radius: 40px;
				overflow: hidden;
				background: #000000;

				img {
					width: 608px;
					// height: 374px;
				}
			}

			.explain {
				font-size: 26px;
				font-family: HarmonyOS Sans SC;
				font-weight: 400;
				color: #4d4d4d;
				margin-top: 32px;
				text-align: center;
				padding-bottom: 50px;
			}
		}

		.footer {
			position: fixed;
			bottom: 0;
			width: 100%;
			height: 143px;
			background: linear-gradient(0deg, #ffffff, #e9f4f2);
			box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
			border-radius: 60px 60px 0px 0px;

			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;

			.btn {
				width: 480px;
				height: 88px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				line-height: 88px;
				border-radius: 44px;
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				color: #ffffff;
				text-align: center;

				img {
					width: 35px;
					margin-right: 25px;
					vertical-align: middle;
				}
			}
		}

		.mask {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 1;
			background: rgba(255, 255, 255, 0.8);
		}

		.dialog {
			width: 665px;
			height: 642px;
			position: fixed;
			z-index: 2;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;
			background: #ffffff;
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border-radius: 60px;

			.title {
				height: 60px;
				font-size: 65px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #ab3b91;
				text-align: center;
				margin-top: 100px;
			}

			.text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 60px;
				text-align: center;
			}

			.mt100 {
				margin-top: 100px;
			}

			.flex {
				display: flex;
				padding: 120px 50px 0 50px;

				.btn {
					width: 260px;
					margin: 0 auto;
					height: 80px;
					line-height: 80px;
					text-align: center;
					font-size: 35px;
					font-family: HarmonyOS Sans SC;
					font-weight: 500;
					color: #ffffff;
					border-radius: 40px;
					background: linear-gradient(132.74deg,
							rgba(0, 187, 177, 1) 0%,
							rgba(0, 86, 140, 1) 74.31%,
							rgba(171, 59, 127, 1) 100%);
				}
			}
		}
	}

	.nextquestionactive {
		background: linear-gradient(138.51deg, rgba(0, 187, 177, 1) 0%, rgba(0, 80, 137, 1) 79.86%, rgba(171, 59, 127, 1) 100%);
		font-size: 32px;
		color: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 218px;
		height: 88px;
		border-radius: 100px;
		margin-right: 10px;
	}

	.next1 {
		width: 28px;
		height: 24px;
		margin-right: 16px;
	}
</style>